import React from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import { Box, Button } from '@mui/material';

interface OpportunityHeaderActionsProps {
  vendorId: string;
  propertyId: string;
}

export default function OpportunityHeaderActions({ vendorId, propertyId }: OpportunityHeaderActionsProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '16px', py: { xs: 1, md: 0 } }}>
      <Button
        variant="outlined"
        color="primary"
        component={RouterLink}
        to={`/vendors/${vendorId}/properties/${propertyId}`}
      >
        Property Info
      </Button>
    </Box>
  );
}
